// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1pBuAQ","heading1":"_2DRtAc","heading2":"_1db0BJ","heading3":"xhlJeR","heading4":"_3T17jZ","heading5":"WyIlgw"};